import React, { useState, useCallback, useMemo } from 'react';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import * as Yup from 'yup';

import { t } from '~/helpers';
import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  Input,
  Select,
  RadioGroup,
} from '~/components/Form';

export default function SaldoContabilCombustivelOrgao() {
  const [open, setOpen] = useState(true);
  const [organ, setOrgan] = useState({});
  const [product, setProduct] = useState({});

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const handleCloseReport = useCallback(() => {
    setOpen(false);
  }, []);

  const handleValidate = useCallback(async (data) => {
    try {
      const schema = Yup.object().shape({
        datahorainicial: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        orgao: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        produto: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(data, { abortEarly: false });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }, []);

  const onSerializeData = useCallback((data) => ({
    ...data,
    orgaostr: organ.orga_nome,
    produtostr: product.prod_descricao,
  }), [organ, product]);

  return (
    <Report
      open={open}
      onClose={handleCloseReport}
      serialize={onSerializeData}
      validate={handleValidate}
      title="Saldo Contábil Combustível do Órgão - Período"
      relatorio="saldocombustivelorgaoperiodo"
      initials={{
        datahorainicial,
        datahorafinal,
        formato: 'pdf',
      }}
    >
      <DateTime time label="Data Inicial" name="datahorainicial" />

      <DateTime time label="Data Final" name="datahorafinal" />

      <Autocomplete
        name="orgao"
        label="orga_nome"
        title="Órgão"
        url="orgaos"
        unique="orga_codigo"
        getValue={(value) => setOrgan(value)}
      />

      <Autocomplete
        name="produto"
        label="prod_display"
        title="Produto"
        url="produtos"
        unique="prod_codigo"
        getValue={(value) => setProduct(value)}
      />

      <RadioGroup
        row
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
      />
    </Report>
  )
}
